// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__f43PK","item":"styles_item__EqeX8"};